export class RiderHelper {
  static getRiderAutoCompleteName(rider) {
    return rider?.firstName ? `${rider?.firstName} ${rider?.lastName}` : '';
  }
}
